// export const reviews = [
//     "Nate was great to work with! Extremely knowledgable, quick and thorough response to answers, and fast delivery. If you're looking for quality work, Nate's your guy. I'll definitely reach out to him again for future projects.",
//     "Exceeded expectations. Highly skilled. Would definitely recommend and use Nate again!",
//     "Understood our complex brief immediately and exceeded expectations — professionalism and an impressive eye for detail.",
//     "Thank you for such speedy and professional work!",
//     "Professional and exhaustively thorough in understanding what we were ultimately looking for and why. Highly recommend.",
//     "Nate not only solved my problem, but made a valuable suggestion that made my project even better. Very responsive.",
//   ];

export const dashboardReviews = [
  {
    quote:
        "Built exactly what I was looking for and delivered it early. I couldn't be happier.",
      author: "Megan G.",
    }

];

export const googleSheetsExpertReviews = [];

export const excelExpertReviews = [
  {
    quote:
      "Nate delivered way more than I expected on my project. He has common sense and can speak normal person talk which is rare when trying to get help with someone as smart as he is. He went above and beyond! I will be a repeat customer if he will have me because I didn't really know what I wanted until he got started.",
    author: "Gina A.",
  },
  {
    quote:
    "Excellent and very informative throughout the process. Would 100% recommend again.",
    author: "Manuel A.",
  },
  {
    quote:
    "Excellent work! He was very good at understanding even though I wasn't very good at explaining what I wanted.",
    author: "Jim J.",
  },
];

export const automationReviews = [

];

export const websiteReviews = [

];

export const seoReviews = [

];

export const appReviews = [

];

export const bookkeepingReviews = [

];

export const itSupportReviews = [

];

export const spreadsheetReviews = [

];

export const dataCleanupReviews = [];

  export const reviews = [
    {
      quote:
        "Nate was great to work with! Extremely knowledgable, quick and thorough response to answers, and fast delivery. If you're looking for quality work, Nate's your guy. I'll definitely reach out to him again for future projects.",
      author: "Alex K.",
    },
    {
      quote: "Exceeded expectations. Would definitely recommend and use Nate again!",
      author: "Evan H.",
    },
    {
      quote:
        "Delivered great work on our data processing project with professionalism and an impressive eye for detail. His politeness, prompt responses, and swift delivery made the collaboration smooth and efficient. 🙌 Great working with Nate; he grasped our complex brief immediately and exceeded expectations!.",
      author: "Matt B",
    },
    {
      quote: "Thank you for such speedy and professional work!",
      author: "Donnell R.",
    },
    {
      quote:
        "Nate really took his time to understand my dilemma and to provide robust solutions. He was professional and engaging and exhaustively thorough in understanding what we were ultimately looking for and why. I will definitely be working with him again and would highly recommend him.",
      author: "Daniel A.",
    },
    {
      quote:
        "Nate not only solved my problem, but made a very valuable suggestion that made my project even better. Very responsive. I appreciate it.",
      author: "Ed K.",
    },
  ];